import { useQuery } from "react-query";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { ConfiguracaoEmailResponse } from "types/response/groupPay/ConfiguracaoEmailResponse";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";
import { opcoesConsultaResiliente } from "shared/util/consultaResiliente";

export const useGetConfiguracaoEmail = () => {
  const consulta = useQuery<Cond21CloudResponse<ConfiguracaoEmailResponse>>({
    queryKey: ["configuracao-group-pay"],
    queryFn: async () => {
      const response = await http.get<Cond21CloudResponse<ConfiguracaoEmailResponse>>(
        api.groupPay.configuracaoEmail
      );
      return response.data;
    },
    ...opcoesConsultaResiliente(
      "configuracao-email-group-pay",
      "Erro ao buscar a configuração de e-mail do Group Pay"
    ),
  });

  return {
    ...consulta,
    /**
     * `isLoading` volta a ser `true` a cada refetch enquanto não houver dado em cache, então
     * usá-lo direto para decidir entre spinner e conteúdo faz a tela oscilar. Aqui o spinner
     * só aparece enquanto a primeira resposta não chegou.
     */
    isCarregandoInicial: consulta.isLoading && !consulta.isFetched,
  };
};
